import { render, staticRenderFns } from "./ThankYouForRegistering.vue?vue&type=template&id=566f8163&scoped=true&"
var script = {}
import style0 from "./ThankYouForRegistering.vue?vue&type=style&index=0&id=566f8163&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566f8163",
  null
  
)

export default component.exports